import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateThirteenLeftColumnSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateThirteenLeftColumnSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor="black">{summary}</ResumePDFText>}
      </View>
    </TemplateThirteenLeftColumnSection>
  );
};
